import { Befehl29 } from '../../../models'

import { Befehl29FormData, Befehl29FormSchema } from './schema'
import { hasAuftrag } from '../converter-utils'
import { Befehl29DataDto } from '../../../dtos/befehl-29-dto'

export const convertModelToBefehl29FormData = (
  befehl?: Befehl29
): Befehl29FormData => {
  const formData = Befehl29FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const has29_10 = hasAuftrag(befehl.auftraege, '29.10')
  const has29_20 = hasAuftrag(befehl.auftraege, '29.20')
  const has29_30 = hasAuftrag(befehl.auftraege, '29.30')

  formData.auftrag_29_10.enabled = has29_10
  formData.auftrag_29_20.enabled = has29_20
  formData.auftrag_29_30.enabled = has29_30

  return formData
}

export const convertBefehl29FormDataToModel = (
  formData: Befehl29FormData,
  frontendId: string
): Befehl29 => {
  const auftraege: Befehl29DataDto = []

  if (formData.auftrag_29_10?.enabled) {
    auftraege.push({
      kennung: '29.10',
      felder: []
    })
  }

  if (formData.auftrag_29_20?.enabled) {
    auftraege.push({
      kennung: '29.20',
      felder: []
    })
  }

  if (formData.auftrag_29_30?.enabled) {
    auftraege.push({
      kennung: '29.30',
      felder: []
    })
  }

  return {
    kennung: '29',
    frontendId,
    auftraege
  }
}
